import React from "react";

export default function ReviewExtension() {
  return (
    <div className="w-full min-h-[30rem] flex flex-col justify-center items-center">
      <h1>No requests received</h1>
    </div>
  );
}
